/*
THIS FILE IS MAINLY for top nav and side nav container accessibilty
    - components in the nav's should have their own local accessibilty functions!
    - e.g (const handleKeyDown => ...)
*/

/**
 * Deep iteration through Child elements to find focusable element
 * which can be either 'a' or 'button' tag
 *
 * @params {object} currentDomEl - Current dom element
 * @return {object} Valid element if found or null
 */
function getFocusableSibling(currentDomEl, direction) {
  if (!currentDomEl) {
    return null;
  }
  var focusableElements = ['A', 'BUTTON', 'header__nav-top__nav-search'];
  var isFocusable = focusableElements.indexOf(currentDomEl.tagName) > -1 || focusableElements.indexOf(currentDomEl.className) > -1;
  if (isFocusable) {
    return currentDomEl;
  }

  // switching between Quick and Revenue navs
  if (direction === 'previous' && currentDomEl.classList.contains('header__nav-top__nav-items')) {
    var navNodes = currentDomEl.querySelectorAll('.header__nav-top__nav-item:not(.header__nav-top__nav-item--hidden)');
    if (navNodes && navNodes.length) {
      return navNodes[navNodes.length - 1];
    }
  }
  return currentDomEl.querySelector('button') || currentDomEl.querySelector('a');
}

/**
 * Finds the next/previous sibling of parent, if not found moves to Grand parent and so on
 * till there is no parent found
 * If a sibling is found then deep iterate through that to find first focusable element
 *
 * @params {object} currentDomEl - Current dom element
 * @params {string} direction - Direction to look for sibling (next or previous)
 * @return {object} Valid element if found or null
 */
function getParentSibling(currentDomEl, direction) {
  var parentElement = currentDomEl && currentDomEl.parentElement;
  if (!parentElement) {
    return null;
  }

  // if it is parent nav item
  if (parentElement.classList.contains('header__nav-top__nav-item') || parentElement.classList.contains('header__nav-side__nav-item')) {
    return parentElement;
  }
  if (parentElement.attributes['data-parent-nav-id']) {
    var parentNavId = parentElement.attributes['data-parent-nav-id'].value;
    var parentNavItem = document.querySelector("[data-nav-id=\"".concat(parentNavId, "\"]"));
    if (parentNavItem) {
      return parentNavItem;
    }
  }
  return getNextSibling(parentElement, direction) || getParentSibling(parentElement, direction);
}

/**
 * Gets the next adjacent element based on the direction
 * Validates if next element found is focusable or not, if not searches for next element in specified direction
 *
 * @params {object} currentDomEl - Current dom element
 * @params {string} direction - Direction to look for sibling (next or previous)
 * @return {object} Valid element if found or null
 */
function getNextSibling(currentDomEl, direction) {
  if (!currentDomEl) {
    return null;
  }
  var nextElement = direction === 'next' ? currentDomEl.nextElementSibling : currentDomEl.previousElementSibling;
  if (nextElement) {
    // If hidden nav item, find next
    if (nextElement.className.indexOf('--hidden') > -1) {
      return getNextSibling(nextElement, direction);
    }

    // Focus on Main Parent Top Nav item rather than deep `a` tag
    if (nextElement.classList.contains('header__nav-top__nav-item') || nextElement.classList.contains('header__nav-side__nav-item')) {
      return nextElement;
    }
    if (nextElement.classList.contains('header__nav-top__nav-items--spillover')) {
      return nextElement.querySelector('.header__nav-top__nav-item');
    }
    return getFocusableSibling(nextElement, direction) || getNextSibling(nextElement, direction);
  }
  return null;
}

/**
 * Opens the Subnav and set the focus on first time
 * Also adds accesibility for 'enter' key
 *
 * @params {number} keyCode - Code for current keyboard key pressed
 * @params {object} currentDomEl - Current dom element
 * @params {boolean} isExpanded - status of subnav expanded or not
 * @params {function} setIsExpanded - method to toggle the subnav state
 * @return {undefined} Sets the focus or navigate to another page
 */
function moveToSubNav(_ref) {
  var event = _ref.event,
    keyCode = _ref.keyCode,
    currentDomEl = _ref.currentDomEl,
    handleActive = _ref.handleActive,
    isExpanded = _ref.isExpanded,
    navPosition = _ref.navPosition;
  var enter = 13;
  event.preventDefault();
  if (isExpanded === false) {
    if (handleActive) {
      handleActive();
    }
  } else if (keyCode === enter && navPosition !== 'side') {
    var focusableSibling = getFocusableSibling(currentDomEl);
    if (focusableSibling) {
      focusableSibling.click();
    }
  } else {
    if (navPosition === 'side' && document) {
      document.querySelector('.header__nav-side__subnav').querySelector('a').focus();
    } else {
      currentDomEl.querySelector('.header__subnav').querySelector('a').focus();
    }
  }
}

/**
 * Grandfather method for whole nav accessibility setup
 *
 * @params {function} closeMenu - Method to toggle side nav
 * @params {object} event - reference event for current nav item
 * @params {boolean} hasSubnav - presence of subnav or not for current nav item
 * @params {boolean} isExpanded - status of subnav expanded or not
 * @params {function} setIsExpanded - method to toggle the subnav state
 * @params {string} navPosition - current position of nav item (top or side)
 * @params {boolean} navSideOpen - status of side nav (open or closed)
 * @params {object} refNavItem - all about current nav item
 *
 * @return {undefined} Adds and triggers the keyboard accessibility
 */
function navAccessibility(_ref2) {
  var closeMenu = _ref2.closeMenu,
    event = _ref2.event,
    hasSubnav = _ref2.hasSubnav,
    handleActive = _ref2.handleActive,
    isExpanded = _ref2.isExpanded,
    setIsExpanded = _ref2.setIsExpanded,
    navPosition = _ref2.navPosition,
    navSideOpen = _ref2.navSideOpen,
    refNavItem = _ref2.refNavItem,
    isDefaultNav = _ref2.isDefaultNav;
  var tab = 9;
  var enter = 13;
  var escape = 27;
  var spaceBar = 32;
  var leftArrow = 37;
  var upArrow = 38;
  var rightArrow = 39;
  var downArrow = 40;
  var keyCode = event.keyCode;
  var currentDomEl = refNavItem && refNavItem.current || event.target;
  var activeElement = document && document.activeElement;
  var onTopNav = activeElement.className.indexOf('header__nav-top__nav-item') > -1;
  var onSubnav = activeElement.classList.contains('header__subnav__item');
  var onSideNav = navPosition === 'side';
  if (onSubnav) {
    if (keyCode === escape) {
      currentDomEl.focus();
      if (setIsExpanded) {
        setIsExpanded(false);
      }
    } else if (keyCode === rightArrow || keyCode === leftArrow || keyCode === downArrow || keyCode === upArrow || keyCode === spaceBar || event.shiftKey && keyCode === tab) {
      if (navPosition === 'side' && keyCode === rightArrow) {
        return undefined; // Do nothing
      }
      event.preventDefault(); // prevent page/sidenav scrolling
      var direction = keyCode === upArrow || keyCode === leftArrow || keyCode === tab ? 'previous' : 'next';
      var nextElement = getNextSibling(activeElement, direction) || getParentSibling(activeElement, direction);
      if (nextElement) {
        nextElement.focus();
      }
    } else if (keyCode === tab) {
      var _nextElement = getNextSibling(activeElement, 'next') || getParentSibling(activeElement, 'next');
      if (_nextElement && _nextElement.className.indexOf('nav-item--parent') > -1) {
        if (setIsExpanded) {
          setIsExpanded(false);
        } else {
          _nextElement.focus();
        }
      }
    }
  } else if (onTopNav || onSideNav) {
    // Shared logic for Top and Side Nav
    if (event.shiftKey && keyCode === tab) {
      var _nextElement2 = getNextSibling(activeElement, 'previous') || getParentSibling(activeElement, 'previous');
      if (_nextElement2 && (_nextElement2.className.indexOf('__nav-item') > -1 ||
      // main nav item
      _nextElement2.className.indexOf('logo__link') > -1 ||
      // mlb/team logo
      _nextElement2.className.indexOf('header__nav-top__button-menu') > -1) //Hamburger
      ) {
        if (setIsExpanded) {
          setIsExpanded(false);
        }
      }
    }
    if (onTopNav) {
      closeMenu(); // Close side nav if open

      if (keyCode === rightArrow || keyCode === leftArrow) {
        var _direction = keyCode === rightArrow ? 'next' : 'previous';
        var _nextElement3 = getNextSibling(currentDomEl, _direction) || getParentSibling(currentDomEl, _direction);
        if (setIsExpanded) {
          setIsExpanded(false);
        }
        if (_nextElement3) {
          _nextElement3.focus();
        }
      } else if (keyCode === spaceBar || keyCode === enter || keyCode === downArrow) {
        if (hasSubnav) {
          moveToSubNav({
            event: event,
            handleActive: handleActive,
            keyCode: keyCode,
            currentDomEl: currentDomEl,
            isExpanded: isExpanded,
            setIsExpanded: setIsExpanded
          });
        } else if (keyCode === enter) {
          getFocusableSibling(currentDomEl).click();
        }
      } else if (keyCode === escape) {
        if (setIsExpanded) {
          setIsExpanded(false);
        }
      }
    } else if (onSideNav) {
      if (keyCode === downArrow || keyCode === upArrow) {
        var menuButton = document.querySelector('.header__nav-top__button-menu');
        var _direction2 = keyCode === downArrow ? 'next' : 'previous';
        var _nextElement4 = getNextSibling(currentDomEl, _direction2);
        if (!_nextElement4 && _direction2 === 'previous') {
          _nextElement4 = menuButton; // Move back to Hamburger icon from first side nav item
        }
        if (!_nextElement4) {
          _nextElement4 = getParentSibling(currentDomEl, 'previous'); // Move back to Top Nav
        }
        if (_nextElement4) {
          _nextElement4.focus();
        }
      } else if (keyCode === spaceBar || keyCode === enter || keyCode === rightArrow) {
        if (hasSubnav) {
          moveToSubNav({
            keyCode: keyCode,
            event: event,
            currentDomEl: currentDomEl,
            handleActive: handleActive,
            isExpanded: isExpanded,
            setIsExpanded: setIsExpanded,
            isDefaultNav: isDefaultNav,
            navPosition: navPosition
          });
        } else if (keyCode === enter) {
          getFocusableSibling(currentDomEl).click();
        } else if (keyCode === spaceBar) {
          event.preventDefault();
        }
      } else if (keyCode === tab && hasSubnav && isExpanded) {
        moveToSubNav({
          event: event,
          navPosition: navPosition
        });
      }
    }
  } else if (keyCode === escape) {
    setIsExpanded(false);
    if (navSideOpen) {
      closeMenu();
      document.querySelector('.header__nav-top__button-menu').focus();
    }
  }
}
export { getParentSibling, getFocusableSibling, getNextSibling, moveToSubNav, navAccessibility };